export const AnnouncementTexts = {
  FIRST_TIME: {
    title: 'Payment details required',
    subText: 'Please set the payment details to unlock dashboard access.',
    btnText: 'Set payment details',
  },
  PAYMENT_FAILED: {
    title: 'Last payment was unsuccessful',
    subText: 'Please update the payment details.',
    btnText: 'Update payment details',
  },
};
